<mat-menu #addMenu>
  <a *ngFor="let blockType of quickBlockTypes" mat-menu-item (click)="addBlock(blockType)">
    <mat-icon>{{blockType.icon}}</mat-icon>
    {{blockType.label}}
  </a>
  <a mat-menu-item (click)="showPicker()">
    <mat-icon>more_horiz</mat-icon>
    More
  </a>
</mat-menu>

<div class="toolbar">

  <mat-button-toggle-group [(ngModel)]="editorMode">
    <mat-button-toggle value="normal" aria-label="Edit">
        <mat-icon>edit</mat-icon>
        Edit
    </mat-button-toggle>
    <mat-button-toggle value="reorder" aria-label="Reorder">
        <mat-icon>drag_handle</mat-icon>
        Reorder
    </mat-button-toggle>
    <mat-button-toggle value="preview" aria-label="Preview">
        <mat-icon>preview</mat-icon>
        View
    </mat-button-toggle>
  </mat-button-toggle-group>

  <div class="spacer"></div>
</div>

<ng-container *ngIf="editorMode === 'preview'">
  <div class="alert alert-info with-icon" *ngIf="isMultiColumn">
    <mat-icon>info</mat-icon>
    <div>
      <strong>Inline preview is not exact</strong><br/>
      Some block features such as stretching from edge to edge are clipped within the editor
      for the best experience. Preview the page directly on TYT.com for the best accuracy.
    </div>
  </div>
  <tyt-content-view [blocks]="blocks"></tyt-content-view>
</ng-container>
<ng-container *ngIf="editorMode !== 'preview'">
  <!-- SINGLE COLUMN, REORDERING -->
  <ng-container *ngIf="editorMode === 'reorder'">
    <div class="alert alert-info with-icon" *ngIf="isMultiColumn">
      <mat-icon>info</mat-icon>
      <div>
        <strong>Reordering will use the single column mode</strong><br/>
        This page uses the Sidebar feature. When viewing this page on phones and tablets, only one column will be used.
        The blocks within the Sidebar will be combined with the blocks in the main column. To enable this, ordering of
        blocks is defined by the single column layout, as would be used on constrained screens.
      </div>
    </div>
    <div class="block-list single-column" [class.reordering-multi]="isMultiColumn" cdkDropList (cdkDropListDropped)="drop($event)">
      <div class="reorder-container" [attr.data-theme]="theme" cdkDrag *ngFor="let block of blocks; trackBy: blockIdentity">
        <tyt-content-block [block]="block">
          <div class="content-block-move-placeholder" *cdkDragPlaceholder></div>
        </tyt-content-block>
        <div class="reordering-indicator">
          <mat-icon>open_with</mat-icon>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="alert alert-info with-icon" *ngIf="editorMode === 'normal'">
    <mat-icon>info</mat-icon>
    <div>
      <strong>Spacing is inaccurate while editing</strong><br/>
      More spacing is added while editing to allow for editor controls. To see an accurate
      rendering of the page, use Preview.
    </div>
  </div>

  <!-- SINGLE COLUMN VIEW WHEN MULTI COLUMN MODE IS ENABLED, USED IN MEDIA QUERIES FOR MOBILE -->
  <ng-container *ngIf="editorMode !== 'reorder'">
    <div class="block-list single-column">
      <tyt-content-block-editor-ui
      *ngFor="let block of blocks; trackBy: blockIdentity"
      [block]="block"></tyt-content-block-editor-ui>

      <div class="actions" *ngIf="editorMode !== 'preview'">
        <button mat-icon-button [matMenuTriggerFor]="addMenu"
                (click)="onClickAddBeforeLast(false)"
                class="add" matTooltip="Add new block">
          <mat-icon>add</mat-icon>
        </button>
      </div>

    </div>
  </ng-container>

  <!-- MULTI COLUMN VIEW WHEN MULTI COLUMN MODE IS ENABLED, USED IN MEDIA QUERIES FOR DESKTOP -->
  <div class="multi-column" *ngIf="shouldUseTwoColumn">
    <div class="block-list primary-column">
      <tyt-content-block-editor-ui
        *ngFor="let block of primaryBlocks; trackBy: blockIdentity"
        [block]="block"></tyt-content-block-editor-ui>
      <div class="actions" *ngIf="editorMode !== 'preview'">
        <button mat-icon-button [matMenuTriggerFor]="addMenu"
                (click)="onClickAddBeforeLast(false)"
                class="add" matTooltip="Add new block to main column">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
    <div class="block-list secondary-column">
      <tyt-content-block-editor-ui
        *ngFor="let block of secondaryBlocks; trackBy: blockIdentity"
        [block]="block"></tyt-content-block-editor-ui>
      <div class="actions" *ngIf="editorMode !== 'preview'">
        <button mat-icon-button [matMenuTriggerFor]="addMenu"
                (click)="onClickAddBeforeLast(true)"
                class="add" matTooltip="Add new block to sidebar">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </div>
</ng-container>